module.exports = __webpack_public_path__ + "static/media/natural-science-min.709774ea.jpg";